/**
 * EPIC 47 — admin-web client for the in-app /notifications bell.
 *
 * Read-own only (per firestore.rules `resource.data.userId == uid()`); writes
 * happen server-side (postMessage creates them, markConversationRead settles
 * them). Queries a single `where(userId)` and sorts client-side — no index.
 */

import type { AppNotification } from '@rendimees24/shared-types';
import { collection, onSnapshot, query, where, type DocumentData } from 'firebase/firestore';

import { getFirebase } from './firebase';

function millis(v: unknown): number {
  if (v && typeof v === 'object' && 'toMillis' in v && typeof (v as { toMillis: () => number }).toMillis === 'function') {
    return (v as { toMillis: () => number }).toMillis();
  }
  if (typeof v === 'string') return Date.parse(v) || 0;
  return 0;
}

/** Live own notifications, newest first. Empty on any read error. */
export function subscribeMyNotifications(
  uid: string,
  onSnap: (rows: AppNotification[]) => void,
): () => void {
  const { firestore } = getFirebase();
  return onSnapshot(
    query(collection(firestore, 'notifications'), where('userId', '==', uid)),
    (snap) => {
      onSnap(
        snap.docs
          .map((d) => ({ id: d.id, ...(d.data() as DocumentData) }) as AppNotification)
          .sort((a, b) => millis(b.createdAt) - millis(a.createdAt)),
      );
    },
    () => onSnap([]),
  );
}
